import { memo, useContext, useMemo } from 'react'
import './index.scss'
import SidebarContext from '../../contexts/SidebarContext/context'
import Icon from '../Icon'
import { closeInfobar, closeSidebar, openInfobar, openSidebar } from '../../contexts/SidebarContext/actions'
import { ICON } from '../Icon/data'

type Sidebar = {
  type?: 'sidebar' | 'infobar'
}

const Sidebar = memo(({ type = 'sidebar' }: Sidebar) => {
  const { sidebar, dispatch } = useContext(SidebarContext)
  const bar = useMemo(() => type === 'sidebar' ? sidebar : sidebar.info_sidebar, [type, sidebar])

  const classNames = useMemo(() => {
    const classArr = [type]
    if (bar?.isOpen) classArr.push('open')
    return classArr.join(' ') 
  }, [bar?.isOpen, type])
  
  const styles = useMemo(() => {
    const styleObj = { width: `${bar?.width}px`, right: '0px' }
    if (!bar?.isOpen) {
      styleObj.right = `calc((${bar?.width}px + 0.5rem) * -1)`
    }
    return styleObj
  }, [bar?.width, bar?.isOpen])

  if (!bar?.content) return null

  const onClick = () => {
    if (bar.isOpen) {
      if (type === 'infobar') dispatch(closeInfobar())
      else dispatch(closeSidebar())
    } else {
      if (type === 'infobar') dispatch(openInfobar())
      else dispatch(openSidebar())
    }
  }

  return (
    <>
      {type === 'infobar' && bar.isOpen && <div className="Blackout" />}
      <div className={`Sidebar ${classNames}`} style={styles}>
        {type === 'sidebar' && (
          <div
            className="Sidebar__control"
            role="button"
            tabIndex={0}
            onClick={() => onClick()}
          >
            <Icon
              icon={bar?.isOpen ? ICON.CHEVRON_RIGHT : ICON.CHEVRON_LEFT}
              color="#ffffff"
              size={16}
            />
          </div>
        )}
        <div className="Sidebar__content">
          {bar.header && (
            <div className="Sidebar__header">
              {bar.header}
              <div
                className="Sidebar__header-close"
                role="button"
                tabIndex={0}
                onClick={() => onClick()}
              >
                <Icon icon={ICON.CLOSE} />
              </div>
            </div>
          )}
          <div className="Sidebar__content-main">{bar?.content}</div>
        </div>
      </div>
    </>
  )
})

export default Sidebar
